import { connectedStore } from '../../store';
import events from '../../utils/events';
import registerInterruption from '../actions/register-interruption';

const setupMessages = () => {
  if (window === window.parent) {
    return;
  }

  events.connect(window, window.parent);

  events.on('ws:subscribe', (event) => {
    const store = connectedStore.get();
    const interruption = event.data;

    store.dispatch(registerInterruption(interruption));
  });
};

export default setupMessages;
